import floorplans from './common/floorplans'
import project from './common/project'

export default {
    data: {
        getProject: {
            id: project.id,
            name: project.name,
            map: project.map,
            floorplans,
        },
    },
}
